const prettifyUrl = (url: string) => {
  url = url?.replace(/^home$/, '');
  if (!url?.startsWith('/')) {
    url = '/' + url;
  }
  return url;
};

module.exports = prettifyUrl;
